export const generatePartnerQueryUrl = (
  baseUrl: string,
  parameters: Record<string, string | boolean | number | undefined>,
): string => {
  return `${baseUrl}?${new URLSearchParams(
    parameters as Record<string, string>,
  )}`;
};
